import React from 'react';
import { Icon } from '@/app/common/icons/Icon';

const MagnifyingGlass = () => (
  <Icon category="UI Essentials" name="icon-magnifying-glass" size={19} color="iconSecondary" />
);

export default MagnifyingGlass;
